import React, { useState, useEffect } from "react";
import axios from 'axios';
import ToastNotification from "../../components/ToastNotification/ToastNotification";
import { VscVerified } from "react-icons/vsc";
import { IoEyeSharp } from "react-icons/io5";
function Withdrawal({
  userData
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const [fetchQuick, setFetchQuick] = useState([]);
  const [withdrawal, setWithdrawal] = useState([]);
  // const [selectedRow, setSelectedRow] = useState(null);
  // const [showModal, setShowModal] = useState(false);
  // const [confirmRow, setConfirmRow] = useState(null);
  const [verifyModal, setVerifyModal] = useState(null);
  const [selectedWalletStaff, setSelectedWalletStaff] = useState(null);
  const [showWalletModal, setShowWalletModal] = useState(false);
  const [paymentData, setPaymentData] = useState({
    pay_id: "",
    pay_mode: "Cash"
  });
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const fetchWithdrawal = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-staff-wthdrawal");
      setWithdrawal(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchQuickService = async () => {
    try {
      const res = await axios.get("https://api.sweepydo.in/fetch-quick-service");
      setFetchQuick(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchWithdrawal();
    fetchQuickService();
  }, []);
  const filteredData = Array.isArray(withdrawal) ? withdrawal.filter(itm => Object.values(itm).some(val => String(val).toLowerCase().includes(searchTerm.toLowerCase()))) : [];
  const handleVerifyWithdrawal = async () => {
    try {
      const payload = {
        staff_id: verifyModal.staff_id,
        pay_id: paymentData.pay_id,
        pay_mode: paymentData.pay_mode,
        pay_status: "Success",
        withdraw_on: new Date().toISOString().slice(0, 19).replace("T", " ")
      };
      await axios.put(`https://api.sweepydo.in/update-withdrawal/${verifyModal.id}`, payload);
      showToast("Withdrawal verified successfully", "success");
      setVerifyModal(null);
      fetchWithdrawal();
    } catch (error) {
      console.log(error);
      showToast("Failed to verify withdrawal", "danger");
    }
  };
  const calculateWallet = staffId => {
    const services = fetchQuick.filter(s => s.staff_id === staffId && s.service_status === "Completed");
    const totalEarnings = services.reduce((sum, item) => {
      const amount = Number(item.amount || 0);
      const com_percent = Number(item.com_percent || 0);
      const actualEarning = amount / (1 + com_percent / 100);
      return sum + actualEarning;
    }, 0);

    // 🔥 2. WITHDRAWALS (UPDATED LOGIC)
    const withdrawals = withdrawal.filter(w => w.staff_id === staffId && w.pay_status !== "Rejected");
    const totalWithdrawals = withdrawals.reduce((sum, item) => {
      const amount = Number(item.amount || 0);
      const com_percent = Number(item.com_percent || 0);

      // ✅ YOUR FINAL RULE
      // const withdrawalValue = amount * com_percent;
      const withdrawalValue = amount + amount * (com_percent / 100);
      return sum + withdrawalValue;
    }, 0);

    // 🔥 3. BASE WALLET
    const baseWallet = totalEarnings - totalWithdrawals;

    // 🔥 4. APPLY LAT %
    const latPercent = Number(userData?.lat || 100);
    return baseWallet * (latPercent / 100);
  };
  return <div className="container-fluid mt-3 mb-3" style={{
    minHeight: "100vh"
  }}>

      <h2 className="mb-4 text-white text-center">Withdrawal Request</h2>
      <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
      <div className="card shadow-lg border-0 p-3 " style={{
      background: "var(--black)",
      borderRadius: "12px"
    }}>
        <div style={{
        background: "var(--black)",
        borderRadius: "12px",
        padding: "15px"
      }}>



          <div className="card-header d-flex justify-content-between align-items-center flex-wrap gap-2 py-4">

            {/* Search */}
            <input type="text" className="form-control w-auto" placeholder="Search..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />

            {/* Month Filter */}
            {/* <input
             type="month"
             className="form-control w-auto"
             value={selectedMonth}
             onChange={(e) => setSelectedMonth(e.target.value)}
             /> */}

          </div>

          <div className="table-responsive">
            <table className="text-center" style={{
            width: "100%",
            borderCollapse: "collapse",
            color: "#fff"
          }}>

              <thead>
                <tr style={{
                backgroundColor: "var(--black2)"
              }}>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>SN</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>STAFF NAME</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>AMOUNT</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>REQUEST DATE</th>




                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>PAYMENT ID</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>PAYMENT MODE</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>PAYMENT STATUS</th>
                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>WITHDRAWAL DATE</th>

                  <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>ACTION</th>
                      <th style={{
                  padding: "18px",
                  textAlign: "center",
                  background: "var(--black2)",
                  color: '#fff'
                }}>VIEW WALLET</th>

                </tr>
              </thead>

              {filteredData.map((s, idx) => <React.Fragment key={s.id}>
                  <tr style={{
                backgroundColor: "var(--black)",
                borderBottom: "1px solid rgba(255,255,255,0.06)",
                transition: "0.3s"
              }} onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = "var(--black2)";
              }} onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = "var(--black)";
              }}>
                    <td style={{
                  padding: "18px",
                  textAlign: "center",
                  verticalAlign: "middle"
                }}>{idx + 1}</td>

                    <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}> {s.staff_name} </td>
                    <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}> {s.amount} </td>

                    <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.req_on}</td>
                    <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.pay_id} </td>
                    <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.pay_mode} </td>
                    <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.pay_status} </td>
                    <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}>{s.withdraw_on} </td>
                    <td>
                    

                      <button className={`btn btn-sm btn-primary ${s.pay_status?.toLowerCase().includes("success") ? "disabled opacity-50" : ""}`} title="Verified Withdrawal" disabled={s.pay_status?.toLowerCase().includes("success")} onClick={() => setVerifyModal(s)}>
  <VscVerified size={20} />
</button>
                    </td>
   <td style={{
                  padding: "18px",
                  textAlign: "center"
                }}> <IoEyeSharp className="text-info" size={26} onClick={() => {
                    setSelectedWalletStaff(s);
                    setShowWalletModal(true);
                  }} /> </td>
                  </tr>


                </React.Fragment>)}


            </table>
          </div>
        </div>


        {verifyModal && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)"
      }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bg-dark text-white border border-secondary">

                {/* Header */}
                <div className="modal-header">
                  <h5 className="modal-title text-warning">Verify Withdrawal</h5>
                  <button className="btn-close btn-close-white" onClick={() => setVerifyModal(null)}></button>
                </div>

                {/* Body */}
                <div className="modal-body">

                  <p className="text-center mb-3">
                    Are you sure you want to verify this withdrawal?
                  </p>

                  <p className="text-info text-center">
                    Staff: {verifyModal.staff_name} | ₹ {verifyModal.amount}
                  </p>


    

                  {/* Payment ID */}
                  <div className="mb-3">
                    <label className="form-label">Payment ID</label>
                    <input type="text" className="form-control" value={paymentData.pay_id} onChange={e => setPaymentData({
                  ...paymentData,
                  pay_id: e.target.value
                })} />
                  </div>

                  {/* Payment Mode */}
                  <div className="mb-3">
                    <label className="form-label">Payment Mode</label>
                    <select className="form-control" value={paymentData.pay_mode} onChange={e => setPaymentData({
                  ...paymentData,
                  pay_mode: e.target.value
                })}>
                      <option value="Cash">Cash</option>
                      <option value="Online">Online</option>
                    </select>
                  </div>

                </div>

                {/* Footer */}
                <div className="modal-footer">

                  <button className="btn btn-secondary" onClick={() => setVerifyModal(null)}>
                    Cancel
                  </button>

                  <button className="btn btn-success" onClick={() => handleVerifyWithdrawal()}>
                    OK
                  </button>

                </div>

              </div>
            </div>
          </div>}





{showWalletModal && selectedWalletStaff && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)"
      }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content bg-dark text-white border border-secondary">

        {/* HEADER */}
        <div className="modal-header">
          <h5 className="modal-title text-info">
            Wallet Details
          </h5>

          <button className="btn-close btn-close-white" onClick={() => setShowWalletModal(false)} />
        </div>

        {/* BODY */}
        <div className="modal-body">

          <p className="text-center text-warning mb-3">
            Staff Wallet Summary
          </p>

          <p className="text-info text-center mb-4">
            👤 {selectedWalletStaff.staff_name}
          </p>

        

          {/* 💸 TOTAL WITHDRAWALS */}
          <div className="d-flex justify-content-between border-bottom py-2">
            <span>💸 Total Withdrawals</span>

           <strong className="text-danger">
   ₹ {withdrawal.filter(w => w.staff_id === selectedWalletStaff.staff_id && w.pay_status !== "Rejected").reduce((sum, w) => {
                    const amount = Number(w.amount || 0);
                    // const com_percent = Number(w.com_percent || 0);

                    // const withdrawalValue = amount * (com_percent / 100);

                    return sum + amount;
                  }, 0).toFixed(2)}
</strong>
          </div>

{/*         
          <div className="d-flex justify-content-between border-bottom py-2">
            <span>📊 Commision %</span>
            <strong className="text-warning">
              {userData?.lat || 100}%
            </strong>
          </div> */}

          {/* 🟢 FINAL WALLET */}
          <div className="d-flex justify-content-between py-3 mt-2">
            <span className="fw-bold">🟢 Earnings in Wallet</span>

            <h5 className="text-info mb-0">
              ₹ {selectedWalletStaff.staff_commission - withdrawal.filter(w => w.staff_id === selectedWalletStaff.staff_id && w.pay_status !== "Rejected").reduce((sum, w) => {
                    const amount = Number(w.amount || 0);
                    // const com_percent = Number(w.com_percent || 0);

                    // const withdrawalValue = amount * (com_percent / 100);

                    return sum + amount;
                  }, 0).toFixed(2)}
              {/* ₹  {calculateWallet(
                selectedWalletStaff.staff_id
               ).toFixed(2)} */}
            </h5>
          </div>

        </div>

        {/* FOOTER */}
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={() => setShowWalletModal(false)}>
            Close
          </button>
        </div>

      </div>
    </div>
  </div>}


      </div>
    </div>;
}
export default Withdrawal;
